
<template>
  <div class="pb-4" v-if="loaded && model">
    <b-card v-if="true" >
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h3>Formulário</h3>
          <b-button
            variant="outline-secondary"
            @click="goBack">
            <feather-icon
              icon="CornerUpLeftIcon"
              class="mr-50"/>
            <span class="align-middle">{{$t('back')}}</span>
          </b-button>
        </div>
      </template>
      <formula :form-definition="model.data" view-only :value="model.data.data"/>
    </b-card>
    <b-card id="attachments" v-if="true" title="Anexos">
      <media-list :show-delete="false" :medias="model.media">
        <template #prepend="prepend">
          <div class="flex justify-center items-center pl-2">
            <a class="text-lg text-primary" @click.prevent="scrollTo(`a${prepend.media.attachment_number}`)">[{{prepend.media.attachment_number}}]</a>
          </div>
        </template>
      </media-list>
      <div class="flex items-center" v-if="model.media.length === 0">
        <feather-icon icon="InfoIcon" class="h-5 w-5 mr-1" />
        <span>Nenhum anexo encontrado.</span>
      </div>
    </b-card>
    <div class="w-full flex gap-2 justify-end">
      <b-button
        variant="outline-secondary"
        class="float-right"
        @click="goBack">
        <feather-icon
          icon="CornerUpLeftIcon"
          class="mr-50"/>
        <span class="align-middle">{{$t('back')}}</span>
      </b-button>
    </div>
  </div>
</template>


<script>
import {
  BButton,
  BCard,
} from 'bootstrap-vue'

import Formula from '@/components/formula/Formula.vue'

import FormManagementService from '@/services/api/form/FormManagementService'
import MediaList from '@/components/media/MediaList.vue'
import { smoothlyGoTo } from '@/util/BrowserUtils'

export default {
  props: {
    id: {
      type: Number,
      default: null,
    }
  },
  components: {
    BButton,
    BCard,
    Formula,
    MediaList
  },
  data: () => ({
    loaded: false,
    service: null,
    model: null
  }),
  methods: {
    detail(id) {
      this.$router.push(`/due-diligence-form/${id}`)
    },
    scrollTo(id) {
      smoothlyGoTo(id)
    },
    goBack() {
      this.$router.push('/due-diligence-form')
    },
  },
  beforeMount() {
    this.service = FormManagementService.build(this.$vs)
    if (this.id) {
      this.$vs.loading()
      this.service.getForm('due-diligence', this.id).then(
        (form) => {
          this.model = form
          this.loaded = true
        },
        (error) => {
          this.notifyError(this.$vs, "Não foi possível carregar o formulário")
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    }
  },
  mounted() {

  }
}
</script>
